<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Tabs</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- Tabs: Tabs -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Tabs</h5>
              <p>Takes the basic nav from above and adds the <code class="text-danger">.nav-tabs</code> class to
                generate
                a tabbed interface. Use them to create tabbable regions with our <a
                  href="javascript:void(0);javascript-behavior">tab
                  JavaScript plugin</a>.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <a class="nav-link active" href="javascript:void(0);">Active</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0);">Link</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0);">Link</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link disabled" href="javascript:void(0);" tabindex="-1"
                        aria-disabled="true">Disabled</a>
                    </li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;nav nav-tabs&quot;&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a class=&quot;nav-link active&quot; href=&quot;#&quot;&gt;Active&lt;/a&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a class=&quot;nav-link&quot; href=&quot;#&quot;&gt;Link&lt;/a&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a class=&quot;nav-link&quot; href=&quot;#&quot;&gt;Link&lt;/a&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a class=&quot;nav-link disabled&quot; href=&quot;#&quot; tabindex=&quot;-1&quot; aria-disabled=&quot;true&quot;&gt;Disabled&lt;/a&gt;
        &lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Tabs: JavaScript behavior -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">JavaScript behavior</h5>
              <p>Use the tab JavaScript plugin—include it individually or through the compiled <code
                  class="text-danger">bootstrap.js</code> file—to extend our navigational tabs and pills to create
                tabbable panes of local content, even via dropdown menus.</p>
              <p>If you’re building our JavaScript from source, it <a
                  href="https://getbootstrap.com/docs/4.5/getting-started/javascript/#util">requires <code
                    class="text-danger">util.js</code></a>.</p>
              <p>Dynamic tabbed interfaces, as described in the <a
                  href="https://www.w3.org/TR/wai-aria-practices/#tabpanel"><abbr
                    title="Web Accessibility Initiative">WAI</abbr> <abbr
                    title="Accessible Rich Internet Applications">ARIA</abbr> Authoring Practices</a>, require <code
                  class="text-danger">role="tablist"</code>, <code class="text-danger">role="tab"</code>, <code
                  class="text-danger">role="tabpanel"</code>, and additional <code class="text-danger">aria-</code>
                attributes in order to convey their structure, functionality and current state to users of assistive
                technologies (such as screen readers).</p>
              <p>Note that dynamic tabbed interfaces should <em>not</em> contain dropdown menus, as this causes both
                usability and accessibility issues. From a usability perspective, the fact that the currently displayed
                tab’s trigger element is not immediately visible (as it’s inside the closed dropdown menu) can cause
                confusion. From an accessibility point of view, there is currently no sensible way to map this sort of
                construct to a standard WAI ARIA pattern, meaning that it cannot be easily made understandable to users
                of
                assistive technologies.</p>
              <div class="card mb-2 shadow-sm">
                <div class="card-body">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                      <a class="nav-link active" id="home-tab" href="javascript:void(0)" (click)="onMenuTab('1')"
                        [ngClass]="{'active': homeTab}">Home</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="profile-tab" href="javascript:void(0)" (click)="onMenuTab('2')"
                        [ngClass]="{'active': profileTab}">Profile</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="contact-tab" href="javascript:void(0)" (click)="onMenuTab('3')"
                        [ngClass]="{'active': contactTab}">Contact</a>
                    </li>
                  </ul>
                  <div class="tab-content mt-2">
                    <div class="tab-pane fade show active" id="home" [ngClass]="{'show active': homeTab}">
                      <p>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown
                        aliqua,
                        retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.
                        Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure
                        terry
                        richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american
                        apparel, butcher voluptate nisi qui.</p>
                    </div>
                    <div class="tab-pane fade" id="profile" [ngClass]="{'show active': profileTab}">
                      <p>Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid.
                        Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four
                        loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk
                        aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore
                        aesthetic
                        magna delectus mollit. Keytar helvetica VHS salvia yr, vero magna velit sapiente labore
                        stumptown.
                        Vegan fanny pack odio cillum wes anderson 8-bit, sustainable jean shorts beard ut DIY ethical
                        culpa terry richardson biodiesel. Art party scenester stumptown, tumblr butcher vero sint qui
                        sapiente accusamus tattooed echo park.</p>
                    </div>
                    <div class="tab-pane fade" id="contact" [ngClass]="{'show active': contactTab}">
                      <p>Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo
                        retro fanny pack lo-fi farm-to-table readymade. Messenger bag gentrify pitchfork tattooed craft
                        beer, iphone skateboard locavore carles etsy salvia banksy hoodie helvetica. DIY synth PBR
                        banksy
                        irony. Leggings gentrify squid 8-bit cred pitchfork. Williamsburg banh mi whatever gluten-free,
                        carles pitchfork biodiesel fixie etsy retro mlkshk vice blog. Scenester cred you probably
                        haven't
                        heard of them, vinyl craft beer blog stumptown. Pitchfork sustainable tofu synth chambray yr.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;nav nav-tabs&quot; id=&quot;myTab&quot; role=&quot;tablist&quot;&gt;
        &lt;li class=&quot;nav-item&quot; role=&quot;presentation&quot;&gt;
            &lt;a class=&quot;nav-link active&quot; id=&quot;home-tab&quot; data-toggle=&quot;tab&quot; href=&quot;#home&quot; role=&quot;tab&quot; aria-controls=&quot;home&quot; aria-selected=&quot;true&quot;&gt;Home&lt;/a&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot; role=&quot;presentation&quot;&gt;
            &lt;a class=&quot;nav-link&quot; id=&quot;profile-tab&quot; data-toggle=&quot;tab&quot; href=&quot;#profile&quot; role=&quot;tab&quot; aria-controls=&quot;profile&quot; aria-selected=&quot;false&quot;&gt;Profile&lt;/a&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot; role=&quot;presentation&quot;&gt;
            &lt;a class=&quot;nav-link&quot; id=&quot;contact-tab&quot; data-toggle=&quot;tab&quot; href=&quot;#contact&quot; role=&quot;tab&quot; aria-controls=&quot;contact&quot; aria-selected=&quot;false&quot;&gt;Contact&lt;/a&gt;
        &lt;/li&gt;
    &lt;/ul&gt;
    &lt;div class=&quot;tab-content&quot; id=&quot;myTabContent&quot;&gt;
        &lt;div class=&quot;tab-pane fade show active&quot; id=&quot;home&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;home-tab&quot;&gt;...&lt;/div&gt;
        &lt;div class=&quot;tab-pane fade&quot; id=&quot;profile&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;profile-tab&quot;&gt;...&lt;/div&gt;
        &lt;div class=&quot;tab-pane fade&quot; id=&quot;contact&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;contact-tab&quot;&gt;...&lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
              <div class="card mb-2 shadow-sm">
                <div class="card-body">
                  <p>The tabs plugin also works with pills.</p>
                  <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <a class="nav-link active" id="pills-home-tab" href="javascript:void(0)" (click)="onMenuPill('1')"
                        [ngClass]="{'active': homePil}">Home</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="pills-profile-tab" (click)="onMenuPill('2')"
                        [ngClass]="{'active': profilePil}">Profile</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="pills-contact-tab" (click)="onMenuPill('3')"
                        [ngClass]="{'active': contactPil}">Contact</a>
                    </li>
                  </ul>
                  <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade active show" id="pills-home" [ngClass]="{'show active': homePil}">
                      <p>Consequat occaecat ullamco amet non eiusmod nostrud dolore irure incididunt est duis anim sunt
                        officia. Fugiat velit proident aliquip nisi incididunt nostrud exercitation proident est nisi.
                        Irure magna elit commodo anim ex veniam culpa eiusmod id nostrud sit cupidatat in veniam ad.
                        Eiusmod consequat eu adipisicing minim anim aliquip cupidatat culpa excepteur quis. Occaecat sit
                        eu exercitation irure Lorem incididunt nostrud.</p>
                    </div>
                    <div class="tab-pane fade" id="pills-profile" [ngClass]="{'show active': profilePil}">
                      <p>Ad pariatur nostrud pariatur exercitation ipsum ipsum culpa mollit commodo mollit ex. Aute sunt
                        incididunt amet commodo est sint nisi deserunt pariatur do. Aliquip ex eiusmod voluptate
                        exercitation cillum id incididunt elit sunt. Qui minim sit magna Lorem id et dolore velit Lorem
                        amet exercitation duis deserunt. Anim id labore elit adipisicing ut in id occaecat pariatur ut
                        ullamco ea tempor duis.</p>
                    </div>
                    <div class="tab-pane fade" id="pills-contact" [ngClass]="{'show active': contactPil}">
                      <p>Est quis nulla laborum officia ad nisi ex nostrud culpa Lorem excepteur aliquip dolor aliqua
                        irure ex. Nulla ut duis ipsum nisi elit fugiat commodo sunt reprehenderit laborum veniam eu
                        veniam. Eiusmod minim exercitation fugiat irure ex labore incididunt do fugiat commodo aliquip
                        sit
                        id deserunt reprehenderit aliquip nostrud. Amet ex cupidatat excepteur aute veniam incididunt
                        mollit cupidatat esse irure officia elit do ipsum ullamco Lorem. Ullamco ut ad minim do mollit
                        labore ipsum laboris ipsum commodo sunt tempor enim incididunt. Commodo quis sunt dolore aliquip
                        aute tempor irure magna enim minim reprehenderit. Ullamco consectetur culpa veniam sint cillum
                        aliqua incididunt velit ullamco sunt ullamco quis quis commodo voluptate. Mollit nulla nostrud
                        adipisicing aliqua cupidatat aliqua pariatur mollit voluptate voluptate consequat non.</p>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;nav nav-pills mb-3&quot; id=&quot;pills-tab&quot; role=&quot;tablist&quot;&gt;
        &lt;li class=&quot;nav-item&quot; role=&quot;presentation&quot;&gt;
          &lt;a class=&quot;nav-link active&quot; id=&quot;pills-home-tab&quot; data-toggle=&quot;pill&quot; href=&quot;#pills-home&quot; role=&quot;tab&quot; aria-controls=&quot;pills-home&quot; aria-selected=&quot;true&quot;&gt;Home&lt;/a&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot; role=&quot;presentation&quot;&gt;
          &lt;a class=&quot;nav-link&quot; id=&quot;pills-profile-tab&quot; data-toggle=&quot;pill&quot; href=&quot;#pills-profile&quot; role=&quot;tab&quot; aria-controls=&quot;pills-profile&quot; aria-selected=&quot;false&quot;&gt;Profile&lt;/a&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot; role=&quot;presentation&quot;&gt;
          &lt;a class=&quot;nav-link&quot; id=&quot;pills-contact-tab&quot; data-toggle=&quot;pill&quot; href=&quot;#pills-contact&quot; role=&quot;tab&quot; aria-controls=&quot;pills-contact&quot; aria-selected=&quot;false&quot;&gt;Contact&lt;/a&gt;
        &lt;/li&gt;
      &lt;/ul&gt;
      &lt;div class=&quot;tab-content&quot; id=&quot;pills-tabContent&quot;&gt;
        &lt;div class=&quot;tab-pane fade show active&quot; id=&quot;pills-home&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;pills-home-tab&quot;&gt;...&lt;/div&gt;
        &lt;div class=&quot;tab-pane fade&quot; id=&quot;pills-profile&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;pills-profile-tab&quot;&gt;...&lt;/div&gt;
        &lt;div class=&quot;tab-pane fade&quot; id=&quot;pills-contact&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;pills-contact-tab&quot;&gt;...&lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <p>And with vertical pills.</p>
                  <div class="row">
                    <div class="col-3">
                      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-home-tab" href="javascript:void(0)"
                          (click)="onMenuPillV('1')" [ngClass]="{'active': homePilV}">Home</a>
                        <a class="nav-link" id="v-pills-profile-tab" href="javascript:void(0)"
                          (click)="onMenuPillV('2')" [ngClass]="{'active': profilePilV}">Profile</a>
                        <a class="nav-link" id="v-pills-messages-tab" href="javascript:void(0)"
                          (click)="onMenuPillV('3')" [ngClass]="{'active': messagesPilV}">Messages</a>
                        <a class="nav-link" id="v-pills-settings-tab" href="javascript:void(0)"
                          (click)="onMenuPillV('4')" [ngClass]="{'active': settingsPilV}">Settings</a>
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-home" [ngClass]="{'show active': homePilV}">
                          <p>Cillum ad ut irure tempor velit nostrud occaecat ullamco aliqua anim Lorem sint. Veniam
                            sint
                            duis incididunt do esse magna mollit excepteur laborum qui. Id id reprehenderit sit est eu
                            aliqua occaecat quis et velit excepteur laborum mollit dolore eiusmod. Ipsum dolor in
                            occaecat
                            commodo et voluptate minim reprehenderit mollit pariatur. Deserunt non laborum enim et
                            cillum
                            eu deserunt excepteur ea incididunt minim occaecat.</p>
                        </div>
                        <div class="tab-pane fade" id="v-pills-profile" [ngClass]="{'show active': profilePilV}">
                          <p>Culpa dolor voluptate do laboris laboris irure reprehenderit id incididunt duis pariatur
                            mollit aute magna pariatur consectetur. Eu veniam duis non ut dolor deserunt commodo et
                            minim
                            in quis laboris ipsum velit id veniam. Quis ut consectetur adipisicing officia excepteur non
                            sit. Ut et elit aliquip labore Lorem enim eu. Ullamco mollit occaecat dolore ipsum id
                            officia
                            mollit qui esse anim eiusmod do sint minim consectetur qui.</p>
                        </div>
                        <div class="tab-pane fade" id="v-pills-messages" [ngClass]="{'show active': messagesPilV}">
                          <p>Fugiat id quis dolor culpa eiusmod anim velit excepteur proident dolor aute qui magna. Ad
                            proident laboris ullamco esse anim Lorem Lorem veniam quis Lorem irure occaecat velit
                            nostrud
                            magna nulla. Velit et et proident Lorem do ea tempor officia dolor. Reprehenderit Lorem
                            aliquip labore est magna commodo est ea veniam consectetur.</p>
                        </div>
                        <div class="tab-pane fade" id="v-pills-settings" [ngClass]="{'show active': settingsPilV}">
                          <p>Eu dolore ea ullamco dolore Lorem id cupidatat excepteur reprehenderit consectetur elit id
                            dolor proident in cupidatat officia. Voluptate excepteur commodo labore nisi cillum duis
                            aliqua do. Aliqua amet qui mollit consectetur nulla mollit velit aliqua veniam nisi id do
                            Lorem deserunt amet. Culpa ullamco sit adipisicing labore officia magna elit nisi in aute
                            tempor commodo eiusmod.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;row&quot;&gt;
        &lt;div class=&quot;col-3&quot;&gt;
            &lt;div class=&quot;nav flex-column nav-pills&quot; id=&quot;v-pills-tab&quot; role=&quot;tablist&quot; aria-orientation=&quot;vertical&quot;&gt;
                &lt;a class=&quot;nav-link active&quot; id=&quot;v-pills-home-tab&quot; data-toggle=&quot;pill&quot; href=&quot;#v-pills-home&quot; role=&quot;tab&quot; aria-controls=&quot;v-pills-home&quot; aria-selected=&quot;true&quot;&gt;Home&lt;/a&gt;
                &lt;a class=&quot;nav-link&quot; id=&quot;v-pills-profile-tab&quot; data-toggle=&quot;pill&quot; href=&quot;#v-pills-profile&quot; role=&quot;tab&quot; aria-controls=&quot;v-pills-profile&quot; aria-selected=&quot;false&quot;&gt;Profile&lt;/a&gt;
                &lt;a class=&quot;nav-link&quot; id=&quot;v-pills-messages-tab&quot; data-toggle=&quot;pill&quot; href=&quot;#v-pills-messages&quot; role=&quot;tab&quot; aria-controls=&quot;v-pills-messages&quot; aria-selected=&quot;false&quot;&gt;Messages&lt;/a&gt;
                &lt;a class=&quot;nav-link&quot; id=&quot;v-pills-settings-tab&quot; data-toggle=&quot;pill&quot; href=&quot;#v-pills-settings&quot; role=&quot;tab&quot; aria-controls=&quot;v-pills-settings&quot; aria-selected=&quot;false&quot;&gt;Settings&lt;/a&gt;
            &lt;/div&gt;
        &lt;/div&gt;
        &lt;div class=&quot;col-9&quot;&gt;
            &lt;div class=&quot;tab-content&quot; id=&quot;v-pills-tabContent&quot;&gt;
                &lt;div class=&quot;tab-pane fade show active&quot; id=&quot;v-pills-home&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;v-pills-home-tab&quot;&gt;...&lt;/div&gt;
                &lt;div class=&quot;tab-pane fade&quot; id=&quot;v-pills-profile&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;v-pills-profile-tab&quot;&gt;...&lt;/div&gt;
                &lt;div class=&quot;tab-pane fade&quot; id=&quot;v-pills-messages&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;v-pills-messages-tab&quot;&gt;...&lt;/div&gt;
                &lt;div class=&quot;tab-pane fade&quot; id=&quot;v-pills-settings&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;v-pills-settings-tab&quot;&gt;...&lt;/div&gt;
            &lt;/div&gt;
        &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>
            <a class="btn btn-dark mb-4" href="https://getbootstrap.com/docs/4.5/components/navs/">Get more details</a>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
